import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $tool } from '@/axios';

// 查询定时任务列表
export const queryCrons: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setCrons', { ...state.list, loading: true });
    const res = await $tool('cron').post('list');
    commit('setCrons', { data: res, loading: false });
  } catch (e) {
    commit('setCrons', { data: [], loading: false });
  }
};

// 修改定时任务
export const editCron: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLoading', true);
    await $tool('cron').post('set', payload);
  } finally {
    commit('setLoading', false);
  }
};

// 启动定时任务
export const startCron: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $tool('cron').get(`${payload}/start`);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 停止定时任务
export const stopCron: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $tool('cron').get(`${payload}/pause`);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 删除定时任务
export const deleteCron: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $tool('cron').post('remove', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};


